import React from 'react';

function Brand (props)
{
    return (
        <div className="brand">
            <img src="/images/brand.png" alt="Marca"/>
        </div>
    )
}

export default Brand;